"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * Custom hook that scrolls to top of page on route changes
 * Also provides a scrollToTop function for manual triggering
 */
export function useScrollToTop() {
  const pathname = usePathname();

  // Scroll to top on route changes
  useEffect(() => {
    if (typeof window === "undefined") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  // Return function for manual scrolling.
  // "instant": i link del menu cambiano pagina subito, senza animare uno
  // scroll-to-top sulla pagina uscente (che dava un ritardo percepito).
  const scrollToTop = () => {
    if (typeof window === "undefined") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  };

  return { scrollToTop };
}
